import {
  faArrowUp,
  faChevronLeft,
  faChevronRight,
  faFilter,
  faSearch,
  faStepBackward,
  faStepForward,
  faTimes,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import intl from 'localization/components'

export const localization = (messages, isLoading = false) => {
  return {
    pagination: {
      firstAriaLabel: messages[intl.generic('first-page')],
      firstTooltip: messages[intl.generic('first-page')],
      previousAriaLabel: messages[intl.generic('previous-page')],
      previousTooltip: messages[intl.generic('previous-page')],
      nextAriaLabel: messages[intl.generic('next-page')],
      nextTooltip: messages[intl.generic('next-page')],
      lastAriaLabel: messages[intl.generic('last-page')],
      lastTooltip: messages[intl.generic('last-page')],
      labelRowsSelect: messages[intl.generic('rows')],
    },
    toolbar: {
      searchTooltip: messages[intl.searchBusiness('search-field')],
      searchPlaceholder: messages[intl.searchBusiness('search-field')],
      searchAriaLabel: messages[intl.searchBusiness('search-field')],
      clearSearchAriaLabel: '',
    },
    header: {
      actions: messages[intl.generic('actions')],
    },
    body: {
      emptyDataSourceMessage: isLoading
        ? 'Loading data...'
        : 'No audit logs found',
    },
  }
}

// Icon size for table actions
const iconStyle = { fontSize: '14px' }
const smallIconStyle = { fontSize: '12px' }

const FilterIcon = () => <FontAwesomeIcon icon={faFilter} style={iconStyle} />
const FirstPageIcon = () => <FontAwesomeIcon icon={faStepBackward} style={iconStyle} />
const LastPageIcon = () => <FontAwesomeIcon icon={faStepForward} style={iconStyle} />
const NextPageIcon = () => <FontAwesomeIcon icon={faChevronRight} style={smallIconStyle} />
const PreviousPageIcon = () => <FontAwesomeIcon icon={faChevronLeft} style={smallIconStyle} />
const SearchIcon = () => <FontAwesomeIcon icon={faSearch} style={iconStyle} />
const SortArrowIcon = ({ className }) => (
  <FontAwesomeIcon icon={faArrowUp} className={className} style={smallIconStyle} />
)
const ClearIcon = () => <FontAwesomeIcon icon={faTimes} style={iconStyle} />

export const icons = {
  Filter: FilterIcon,
  FirstPage: FirstPageIcon,
  LastPage: LastPageIcon,
  NextPage: NextPageIcon,
  PreviousPage: PreviousPageIcon,
  Search: SearchIcon,
  SortArrow: SortArrowIcon,
  Clear: ClearIcon,
  ResetSearch: ClearIcon,
}
